
import XHeader from 'vux/src/components/x-header/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Panel from 'vux/src/components/panel/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'


export default {
directives: {
TransferDom
},
components: {
XHeader,
Actionsheet,
Panel,
Search,
Loading,
Scroller
},
name: 'GoodsList',
data () {
return {
menus: {
'-1': '全部商品',
'0': '未上架商品',
'1': '已上架商品'
},
showMenus: false,
goodsList: [],
footer: {
title: '',
url: '/goods/goods_list'
},
searchTerm: '',
isOnSale: 1,
keyword: '',
page: 1,
pullupDefaultConfig: {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
},
pageCount: 1,
title: '已上架商品列表'
}
},
created () {
this.page = 1
this.goodsList.length = 0
this.reloadGoods()
},







methods: {
reloadGoods () {
const payload = {
isOnSale: this.isOnSale,
keyword: this.keyword,
page: this.page
}
const that = this
that.$vux.loading.show({
text: '商品加载中...'
})
this.$store.dispatch('getGoodsList', payload).then((res) => {
console.log(res)
that.pageCount = res.pageCount
console.log(that.page + '-' + that.pageCount)
const goodsList = res.data
if (goodsList.length > 0) {
goodsList.forEach((goods) => {
that.goodsList.push({
src: goods.original_img,
title: goods.goods_name,
desc: '<span style="font-size: 18px;color:red">¥ ' + goods.shop_price,
url: {
path: '/goods/goods_edit?goods_id=' + goods.goods_id,
replace: false
},
meta: {
source: '<span style="font-size: 16px;">库存: ' + goods.store_count + '</span>',
date: ' ',
other: '<span style="font-size: 16px;">累计销量: ' + goods.sales_sum + '</span>'
}
})
})
}




const isLastPage = that.page >= that.pageCount
if (isLastPage) {
this.$refs.scrollerView.disablePullup()
} else {
this.$refs.scrollerView.enablePullup()
this.$refs.scrollerView.donePullup()
}
that.page = res.pageNext
that.$vux.loading.hide()
})
},
doSelect (key) {
if (key === '1') {
this.title = '已上架商品列表'
} else if (key === '0') {
this.title = '未上架商品列表'
} else {
this.title = '全部商品列表'
}
this.isOnSale = key
this.page = 1
this.keyword = ''
this.goodsList.length = 0
this.$refs.scrollerView.reset({top: 0})
this.reloadGoods()
},
onSearchGoods () {
this.keyword = this.searchTerm
this.page = 1
this.goodsList.length = 0
this.goodsList = []
this.$refs.scrollerView.reset({top: 0})
this.reloadGoods()
},
onImgError (item, $event) {
console.log(item, $event)
},
loadMoreData () {
console.log('加载条数页数' + this.page + '-' + this.pageCount)
if (this.page <= this.pageCount) {

this.reloadGoods()
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/goods/GoodsList.vue